@let title = currentRendering.subfeatures.page.selectors.title.asSignal();
@let pageBreadcrumbs =
  currentRendering.subfeatures.page.selectors.breadcrumbs.asSignal();
@let segmentBreadcrumbs =
  currentRendering.subfeatures.segments.selectors.currentSegmentBreadcrumbs.asSignal();
@let breadcrumbs = pageBreadcrumbs.concat(segmentBreadcrumbs);
@let hasVariables = hasVariablesSg();
@let error = currentRendering.subfeatures.page.selectors.error.asSignal();
@let hasAppliedVariableValues = hasAppliedVariableValuesSg();

@defer (on timer(200)) {
  @if (currentRendering.subfeatures.page.selectors.isLoading.asSignal()) {
    <div class="atn-mosaic-page-header__loader-wrapper">
      <atn-ds-loader type="header" />
    </div>
  } @else if (error) {
    Error is {{ error }}
  } @else if (title || breadcrumbs.length || hasVariables) {
    <atn-ds-page-header
      [name]="title"
      [breadcrumbs]="breadcrumbs"
      [loading]="
        currentRendering.subfeatures.page.selectors.isLoading.asSignal()
      "
      [error]="currentRendering.subfeatures.page.selectors.error.asSignal()"
      pageHeader
    >
      @if (hasVariables) {
        <ng-container actions>
          <i
            class="atn-icon atn-funnel atn-blue"
            [class.atn-mosaic-page-header__icon-with-info]="
              hasAppliedVariableValues
            "
            (click)="filtersIconClickHandler()"
          ></i>
        </ng-container>
      }
    </atn-ds-page-header>
  }
}
